import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import FaqAccordion from "../components/site/FaqAccordion";
import FinalCTA from "../components/site/FinalCTA";
import BarloVideo from "../components/site/BarloVideo";
import { Dot } from "../components/site/Section";
import { REGISTER_URL, HOME_FAQS } from "../data/content";

// Home: hero, the problem, how Barlo fixes it (3 features), prices, FAQ.
export default function Home() {
  return (
    <div className="App">
      <Navbar />
      <main>
        {/* HERO */}
        <section className="hero" data-testid="hero-section">
          <div className="wrap hero-grid">
            <div className="hero-copy">
              <h1 data-testid="hero-title">
                <span className="label h1-kicker">Bar stock control and supplier ordering for UK bars and restaurants</span>
                Know what's in stock, what it makes you and what to order<Dot />
              </h1>
              <p className="lede" data-testid="hero-sub">
                Drinks stock control for independent bars, pubs and restaurants. Film your shelves and talk while you count.
                Barlo turns it into a stock count, takes your sales off, and builds the order for every supplier. You check it and send it.
              </p>
              <div className="cta-row">
                <a className="btn btn-green" href={REGISTER_URL} data-testid="hero-trial">Start free trial</a>
                <Link className="btn btn-ghost" to="/features" data-testid="hero-see-how">See how it works</Link>
              </div>
              <p className="fine"><strong>14 days free, no card.</strong> Everything in Pro during the trial. From £29 a month per venue.</p>
              <p className="fine">Built in Leeds by a hospitality manager with 11 years in bars and restaurants.</p>
            </div>
            <div className="hero-media">
              <figure className="photo tall">
                <img src="/img/hero-bar.webp" srcSet="/img/hero-bar-800.webp 800w, /img/hero-bar.webp 1122w"
                  sizes="(max-width: 900px) 100vw, 45vw" width="1122" height="1402" fetchPriority="high"
                  alt="Bartender counting a back bar shelf of aperitivo, bitter and gin by filming it with the Barlo stocktake app" />
              </figure>
              <div className="float-card" aria-hidden="true">
                <div className="fc-head"><b>Back bar, shelf 2</b><span className="fc-rec"><i />Counting</span></div>
                <div className="fc-row"><span className="tick" /><span>Vellani Aperitivo 70cl</span><b>0.6</b></div>
                <div className="fc-row"><span className="tick" /><span>Rosso Corvo Bitter 70cl</span><b>1.4</b></div>
                <div className="fc-row"><span className="tick" /><span>Kestrel Lane Gin 70cl</span><b>0.7</b></div>
                <div className="fc-row"><span className="tick" /><span>Saltmere Blue Gin 70cl</span><b>0.3</b></div>
              </div>
            </div>
          </div>
        </section>

        {/* THE PROBLEM */}
        <section className="problem2">
          <div className="wrap">
            <div className="sec-head">
              <h2>Stocktake shouldn't take all morning<Dot /></h2>
              <p className="lede">Counting on paper, ordering supplier by supplier, and price rises nobody spots until the GP drops.</p>
            </div>
            <div className="pains">
              <div className="pain"><b>2 to 3 hours</b><span>counting the bar, fridges and cellar by hand</span></div>
              <div className="pain"><b>1 hour</b><span>ordering, one supplier at a time</span></div>
              <div className="pain"><b>Rarely</b><span>are supplier price rises spotted on time</span></div>
            </div>
          </div>
        </section>

        {/* HOW BARLO FIXES IT */}
        <section className="solution" id="in-action" data-testid="features-section">
          <div className="wrap">
            <div className="sec-head">
              <h2>Count it, cost it, order it<Dot /></h2>
            </div>
            <BarloVideo />
            <div className="three">
              <div className="three-item"><span className="num">1</span><h3>Film &amp; count</h3><p>Film each shelf, fridge and cellar and talk while you go. Barlo counts it, you check and confirm.</p></div>
              <div className="three-item"><span className="num">2</span><h3>Know what every drink makes</h3><p>Every drink and cocktail costed per serve, GP on every line, and price rises flagged when the invoice comes in.</p></div>
              <div className="three-item"><span className="num">3</span><h3>The order, built and sent</h3><p>Barlo builds the weekly order from your sales and par levels. Check it, then email every supplier in one tap.</p></div>
            </div>
          </div>
        </section>

        {/* PRICES */}
        <section className="band">
          <div className="wrap band-grid">
            <div>
              <h2>From £29 a month per venue<Dot /></h2>
              <p>Two plans, Starter and Pro. Try everything in Pro free for 14 days, no card, then pick the one that fits.</p>
              <div className="cta-row" style={{ marginTop: 24 }}><Link className="btn btn-green" to="/pricing">See pricing</Link></div>
            </div>
            <div className="formats">
              <div className="format"><b>£29</b><span>Starter, a month per venue</span></div>
              <div className="format"><b>£39</b><span>Pro, a month per venue</span></div>
              <div className="format"><b>10%</b><span>Off when you pay yearly</span></div>
              <div className="format"><b>14 days</b><span>Free, no card</span></div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section data-testid="faq-section">
          <div className="wrap faq-grid">
            <div><h2>Questions owners ask us<Dot /></h2></div>
            <FaqAccordion items={HOME_FAQS}>
              <p style={{ paddingTop: 20 }}><Link className="btn btn-ghost" to="/faq">See all questions</Link></p>
            </FaqAccordion>
          </div>
        </section>

        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
